import { InputHasErrorProp, baseStyles } from './styles'
import { ChangeEvent, FC, TextareaHTMLAttributes, useRef, useState } from 'react'
import styled from 'styled-components'
import { minHeight } from 'styled-system'

const StyledTextarea = styled.textarea<InputHasErrorProp>`
  ${baseStyles};
  resize: none;
  border: 1px solid ${(p) => p.theme.colors.shades[500]};
  padding: 0.625rem;
  height: 100px;
  line-height: 1.4;
  ${minHeight};

  &::placeholder {
    opacity: 1;
  }
`

export interface TextareaProps
  extends InputHasErrorProp,
    TextareaHTMLAttributes<HTMLTextAreaElement> {
  autosize?: boolean
  minRows?: number
  maxRows?: number
}

export const Textarea: FC<TextareaProps> = ({ autosize, minRows, maxRows, onChange, ...rest }) => {
  const lineHeight = 23
  const ref = useRef<HTMLTextAreaElement | null>(null)
  const [rows, setRows] = useState(minRows || 5)

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    if (autosize && e.target) {
      const newRows = Math.round(e.target.scrollHeight / lineHeight)
      if (newRows > e.target.rows) {
        if (maxRows) {
          if (newRows < maxRows) {
            setRows(newRows)
          }
        } else {
          setRows(newRows)
        }
      }
    }

    onChange && onChange(e)
  }
  return (
    <StyledTextarea
      rows={autosize ? rows : minRows ? minRows : undefined}
      onChange={handleChange}
      ref={ref}
      data-field-id={rest.name}
      {...rest}
    />
  )
}
